import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/common/Layout";
import { Skeleton } from "@/components/ui/skeleton";

export function DataTable({ columns, rows, loading, empty, onRowClick, testId, rowTestId }) {
  return (
    <div className="overflow-x-auto">
      <table data-testid={testId} className="w-full min-w-[720px] border-collapse">
        <thead className="bg-slate-100/80">
          <tr className="border-b border-slate-200">
            {columns.map((col) => (
              <th key={col.key} className="th" style={col.width ? { width: col.width } : undefined}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading
            ? Array.from({ length: 6 }).map((_, i) => (
                <tr key={i} className="border-b border-slate-100">
                  {columns.map((col) => (
                    <td key={col.key} className="cell">
                      <Skeleton className="h-4 w-24" />
                    </td>
                  ))}
                </tr>
              ))
            : rows.map((row, index) => (
                <tr
                  key={row.id || index}
                  data-testid={rowTestId ? `${rowTestId}-${row.id || index}` : undefined}
                  onClick={onRowClick ? () => onRowClick(row) : undefined}
                  className={`border-b border-slate-100 transition-colors duration-150 hover:bg-indigo-50/50 ${
                    onRowClick ? "cursor-pointer" : ""
                  }`}
                >
                  {columns.map((col) => (
                    <td key={col.key} className="cell">
                      {col.render ? col.render(row) : (row[col.key] ?? "—")}
                    </td>
                  ))}
                </tr>
              ))}
        </tbody>
      </table>
      {!loading && rows.length === 0 ? (
        <EmptyState
          testId="table-empty-state"
          title={empty?.title || "Nothing to show yet"}
          description={empty?.description}
          action={empty?.action}
        />
      ) : null}
    </div>
  );
}

export function Pagination({ page, pages, total, onChange, testId = "pagination" }) {
  if (!total) return null;
  return (
    <div data-testid={testId} className="flex items-center justify-between border-t border-slate-200 px-4 py-2.5">
      <span className="text-xs text-slate-500">
        Page {page} of {pages} · {total.toLocaleString()} records
      </span>
      <div className="flex gap-2">
        <Button
          data-testid="pagination-prev"
          size="sm"
          variant="outline"
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
        >
          Previous
        </Button>
        <Button
          data-testid="pagination-next"
          size="sm"
          variant="outline"
          disabled={page >= pages}
          onClick={() => onChange(page + 1)}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
